<template>
  <ul>
    <li v-for="option in _options" :key="option.id">
      <input type="radio"
             :id="option.id"
             :name="questionId"
             :value="option.value"
             :checked="option.selected"
             @change="select(option)"
      >
      <label :for="option.id">{{ option.label }}</label>
    </li>
  </ul>
</template>

<script>
/* eslint-disable no-underscore-dangle, no-param-reassign */
export default {
  data: () => ({
    // eslint-disable-next-line vue/no-reserved-keys
    _options: null,
  }),
  props: {
    questionId: String,
    options: Array,
  },
  methods: {
    select(option) {
      this._options.forEach((o) => delete o.selected);
      option.selected = true;
      this.$emit('change', this._options);
    },
  },
  watch: {
    questionId() {
      // does not fire for the first question (or last, if going back)
      this._options = this.options;
    },
  },
  created() {
    // fires only for the first question (or last, if going back)
    this._options = this.options;
  },
};
</script>

<style lang="scss">
.kws-quiz {
  input[type=radio] + label::before {
    width: rem(20px);
    height: rem(20px);
    inset-inline-start: rem(10px);
    border: 2px solid #c8d0d6;
  }

  input[type=radio] + label::after {
    width: rem(8px);
    height: rem(8px);
    inset-inline-start: rem(10px);
  }

  input[type=radio] + label::before,
  input[type=radio] + label::after {
    content: '';
    display: block;
    color: #fff;
    background-color: #fff;
    font-size: 1rem;
    line-height: 1;
    border-radius: 50%;
    position: absolute;
    top: rem(20px);
    transform: translate(-50%, -50%);
  }
  html[dir=rtl] & input[type=radio] + label::before,
  html[dir=rtl] & input[type=radio] + label::after {
    transform: translate(50%, -50%);
  }

  input.form-control[type=radio] + label::before {
    transition: all .2s ease
  }

  input[type=radio]:checked + label {
    &::before {
      border-color: $color-kws-orange;
    }

    &::after {
      background-color: $color-kws-orange;
    }
  }
}
</style>
